"use strict";var isObject=require("./_is-object");require("./_object-sap")("isExtensible",function(e){return function(t){return!!isObject(t)&&(!e||e(t))}});